/*
  ToDO: Temporal implementation, should be replaced by the dynamic mapping
  from the CMS in the shape of: field, value_current, value_override
*/

import { InventoryField } from '@lamesarv-sdk/types';

export enum InventoryType {
  new = 'New',
  used = 'Used',
}

export const InventoryTypeMap: Record<string, string> = {
  New: 'New',
  Used: 'Preowned',
};

export const getInventoryType = (type: string): string => {
  return InventoryTypeMap[type] || type;
};

export const revertInventoryType = (type: string): string => {
  const entry = Object.entries(InventoryTypeMap).find(([, value]) => value === type);
  return entry ? entry[0] : type;
};

export enum MessageFavoritesType {
  favoriteSelectInventory = 'favoriteSelectInventory',
  favoriteUnselectInventory = 'favoriteUnselectInventory',
}

export interface IMessageFavorites {
  type: MessageFavoritesType;
  id?: string;
  quantity?: number;
}

export type BaseFilters = Partial<Record<InventoryField, string[]>>;

export enum FilterSection {
  SORT_BY = 'Sort By',
  PROMOTIONS = 'Promotions',
  CONDITION = 'Condition',
  RV_TYPE = 'RV Type',
  MAKE = 'Make',
  MODEL = 'Model',
  FLOOR_PLAN = 'Floor Plan',
  LENGTH = 'Length',
  LOCATION = 'Location',
  PRICE = 'Price',
  FEATURES = 'Features',
  FUEL_TYPE = 'Fuel Type',
  // CHASSIS = 'Chassis',
  // SLEEPS = 'Sleeps',
  YEAR = 'Year',
  // DRIVE_TRAIN = 'Drive Train',
  SLIDEOUTS = 'Slideouts',
}

export enum SortBy {
  RECOMMENDED = 'Recommended',
  PRICE_LOW_TO_HIGH = 'Price: Low to High',
  PRICE_HIGH_TO_LOW = 'Price: High to Low',
  NEWEST = 'Newest',
  OLDEST = 'Oldest',
}

export enum FilterPromotion {
  FLASH_SALE = 'Flash Sale',
  DAILY_DEAL = 'Daily Deal',
}

export const FilterPromotionInventoryField: Record<FilterPromotion, InventoryField> = {
  [FilterPromotion.FLASH_SALE]: InventoryField.isFlashSale,
  [FilterPromotion.DAILY_DEAL]: InventoryField.isDailyDeal,
};

export interface RangeFilterValue {
  min: number;
  max: number;
}

export type FilterValue = string[] | RangeFilterValue;

export type Filters = Partial<Record<FilterSection, FilterValue>>;
